import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export type QueryKeys =
  | 'page'
  | 'limit'
  // Programs
  | 'programTemplateId'
  | 'programCreatedAtStart'
  | 'programCreatedAtEnd'
  | 'excludeNonVoucherPrograms'
  // Applications
  | 'showIndividualApplications'
  | 'applicationStates'
  | 'applicationCreatedAtStart'
  | 'applicationCreatedAtEnd'
  | 'inCollections'
  // Payments
  | 'includePayments'
  | 'paymentStates'
  | 'paymentYear'
  // Courses
  | 'includeCourses'
  | 'coursesBeginDate'
  | 'coursesEndDate'
  // Employees
  | 'employeeId'
  | 'terminatedEmployees'
  | 'excludeTermVerified'
  // Invoices
  | 'includeInvoiceDate'
  | 'approverId'
  // Columns
  | 'selectedColumns';

export default class AuthenticatedAdminReportingTasProgramsController extends Controller {
  @tracked page = 1;
  @tracked limit = 50;
  // Programs
  @tracked programTemplateId = '';
  @tracked programCreatedAtStart = '';
  @tracked programCreatedAtEnd = '';
  @tracked excludeNonVoucherPrograms = false;
  // Applications
  @tracked showIndividualApplications = false;
  @tracked applicationStates = '';
  @tracked applicationCreatedAtStart = '';
  @tracked applicationCreatedAtEnd = '';
  @tracked inCollections = false;
  // Courses
  @tracked includeCourses = false;
  @tracked coursesBeginDate = '';
  @tracked coursesEndDate = '';
  // Payments
  @tracked includePayments = false;
  @tracked paymentStates = '';
  @tracked paymentYear = '';
  // Employees
  @tracked employeeId = '';
  @tracked terminatedEmployees = false;
  @tracked excludeTermVerified = false;
  // Invoices
  @tracked includeInvoiceDate = false;

  @tracked approverId = '';

  // Column selection with sensible defaults (stored as comma-separated string for query params)
  // These must match the property names in AggregatedProgramInstance from the data provider
  @tracked
  selectedColumns = [
    'employeeNameKeyword',
    'payrollId',
    'tasProgramInstanceFieldNameKeyword',
    'tasProgramInstanceFieldSchoolInstitutionNameKeyword',
  ].join(',');

  queryParams = [
    'page',
    'limit',
    // Programs
    'programTemplateId',
    'programCreatedAtStart',
    'programCreatedAtEnd',
    'excludeNonVoucherPrograms',
    // Applications
    'showIndividualApplications',
    'applicationStates',
    'applicationCreatedAtStart',
    'applicationCreatedAtEnd',
    'inCollections',
    // Payments
    'includePayments',
    'paymentStates',
    'paymentYear',
    // Courses
    'includeCourses',
    'coursesBeginDate',
    'coursesEndDate',
    // Employees
    'employeeId',
    'terminatedEmployees',
    'excludeTermVerified',
    // Invoices
    'includeInvoiceDate',
    'approverId',
    // Columns
    'selectedColumns',
  ];
}
